import UserGroupsSection from "@/components/sections/UserGroupsSection";

const UserGroups = () => {
    return (
        <div className="container flex-1 flex-col flex-wrap items-center px-2 py-4 md:px-3 lg:px-4">
            <UserGroupsSection />
        </div>
    );
};

export default UserGroups;
